'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchemaAccessor = function () {
  function SchemaAccessor(ctx) {
    _classCallCheck(this, SchemaAccessor);

    this.ctx = ctx;
    this.schema = ctx.schema;

    this.navConfigs = this.getNavConfig();
  }

  SchemaAccessor.prototype.getPageId = function getPageId() {
    return this.ctx.getCurrentPageId();
  };

  SchemaAccessor.prototype.getNavConfig = function getNavConfig() {
    if (this.schema.nav && this.schema.nav.singletons && this.schema.nav.singletons[this.getPageId()] && this.schema.nav.singletons[this.getPageId()].singleton) {
      return _extends({}, this.schema.nav, this.schema.nav.singletons[this.getPageId()]);
    }
    return this.schema.nav;
  };

  SchemaAccessor.prototype.hasSideNav = function hasSideNav() {
    var navType = this.getNavType();
    return navType === 'top_side_fold' || navType === 'top_side';
  };

  SchemaAccessor.prototype.getNavLayout = function getNavLayout() {
    return this.navConfigs && this.navConfigs.layout;
  };

  SchemaAccessor.prototype.getNavType = function getNavType() {
    return this.navConfigs && this.navConfigs.type;
  };

  return SchemaAccessor;
}();

exports.default = SchemaAccessor;
module.exports = exports['default'];